import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.promise.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import merge from "lodash/merge";
import { SocialMediaType } from "./types/user.types";
import { DATE_CONSIDERATIONS, extractFromFullName, handle } from "@dp/common";
import moment from "moment-timezone";
import { UIError } from "./errors";
var PAYLOAD_CONSTANTS = {
  JAVA_UTIL_HASHMAP: "java.util.HashMap",
  CREDIT_CARD_BEAN: "com.darden.commerce.order.purchase.CreditCardBean"
};

var User = /*#__PURE__*/function () {
  function User(config, axios) {
    _classCallCheck(this, User);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "_lastSessionDetailTimeStamp", 0);

    this.axios = axios;
    this.config = config;
  }

  _createClass(User, [{
    key: "getSessionDetails",
    value: function () {
      var _getSessionDetails = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var _this = this;

        var jwtToken, headers;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                jwtToken = _ref.jwtToken;
                headers = {};

                if (jwtToken) {
                  headers = {
                    Authorization: "Bearer ".concat(jwtToken)
                  };
                }

                _context.next = 5;
                return this.axios.get(this.config.postfix.INIT_DETAILS, {
                  headers: headers
                }).then(function (resp) {
                  return _this._processInitDetails(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSessionDetails(_x) {
        return _getSessionDetails.apply(this, arguments);
      }

      return getSessionDetails;
    }()
  }, {
    key: "_processInitDetails",
    value: function _processInitDetails(response) {
      var _response$data, _successResp$orderCon, _successResp$orderCon2, _successResp$orderCon3, _successResp$orderCon4, _successResp$orderCon5, _successResp$orderCon6, _successResp$orderCon7, _successResp$orderCon8, _successResp$orderCon9, _successResp$orderCon10, _successResp$delivery, _successResp$delivery2, _successResp$delivery3, _successResp$delivery4, _successResp$delivery5, _successResp$delivery6, _successResp$delivery7, _successResp$delivery8;

      this._lastSessionDetailTimeStamp = Date.now();
      var successResp = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.response;
      var isOrderContextMissing = (successResp === null || successResp === void 0 ? void 0 : successResp.orderContext) === undefined;
      return merge(successResp, {
        orderContext: {
          orderTypeValue: isOrderContextMissing ? 0 : successResp === null || successResp === void 0 ? void 0 : (_successResp$orderCon = successResp.orderContext) === null || _successResp$orderCon === void 0 ? void 0 : _successResp$orderCon.orderTypeValue,
          showCalories: isOrderContextMissing ? true : successResp === null || successResp === void 0 ? void 0 : (_successResp$orderCon2 = successResp.orderContext) === null || _successResp$orderCon2 === void 0 ? void 0 : _successResp$orderCon2.showCalories,
          actualPickupDateTime: successResp !== null && successResp !== void 0 && (_successResp$orderCon3 = successResp.orderContext) !== null && _successResp$orderCon3 !== void 0 && _successResp$orderCon3.actualPickupDate && successResp !== null && successResp !== void 0 && (_successResp$orderCon4 = successResp.orderContext) !== null && _successResp$orderCon4 !== void 0 && _successResp$orderCon4.actualPickupTime ? moment((successResp === null || successResp === void 0 ? void 0 : (_successResp$orderCon5 = successResp.orderContext) === null || _successResp$orderCon5 === void 0 ? void 0 : _successResp$orderCon5.actualPickupDate) + " " + (successResp === null || successResp === void 0 ? void 0 : (_successResp$orderCon6 = successResp.orderContext) === null || _successResp$orderCon6 === void 0 ? void 0 : _successResp$orderCon6.actualPickupTime), DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_SLASH).toDate() : null,
          updated_EDateTime: successResp !== null && successResp !== void 0 && (_successResp$orderCon7 = successResp.orderContext) !== null && _successResp$orderCon7 !== void 0 && _successResp$orderCon7.updated_EDate && successResp !== null && successResp !== void 0 && (_successResp$orderCon8 = successResp.orderContext) !== null && _successResp$orderCon8 !== void 0 && _successResp$orderCon8.updated_ETime ? moment((successResp === null || successResp === void 0 ? void 0 : (_successResp$orderCon9 = successResp.orderContext) === null || _successResp$orderCon9 === void 0 ? void 0 : _successResp$orderCon9.updated_EDate) + " " + (successResp === null || successResp === void 0 ? void 0 : (_successResp$orderCon10 = successResp.orderContext) === null || _successResp$orderCon10 === void 0 ? void 0 : _successResp$orderCon10.updated_ETime), DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_SLASH).toDate() : null
        },
        deliveryGroup: {
          deliveryServiceDateTime: {
            actualDeliveryDateTime: successResp !== null && successResp !== void 0 && (_successResp$delivery = successResp.deliveryGroup) !== null && _successResp$delivery !== void 0 && (_successResp$delivery2 = _successResp$delivery.deliveryServiceDateTime) !== null && _successResp$delivery2 !== void 0 && _successResp$delivery2.deliveryDate && successResp !== null && successResp !== void 0 && (_successResp$delivery3 = successResp.deliveryGroup) !== null && _successResp$delivery3 !== void 0 && (_successResp$delivery4 = _successResp$delivery3.deliveryServiceDateTime) !== null && _successResp$delivery4 !== void 0 && _successResp$delivery4.deliveryTime ? moment((successResp === null || successResp === void 0 ? void 0 : (_successResp$delivery5 = successResp.deliveryGroup) === null || _successResp$delivery5 === void 0 ? void 0 : (_successResp$delivery6 = _successResp$delivery5.deliveryServiceDateTime) === null || _successResp$delivery6 === void 0 ? void 0 : _successResp$delivery6.deliveryDate) + " " + (successResp === null || successResp === void 0 ? void 0 : (_successResp$delivery7 = successResp.deliveryGroup) === null || _successResp$delivery7 === void 0 ? void 0 : (_successResp$delivery8 = _successResp$delivery7.deliveryServiceDateTime) === null || _successResp$delivery8 === void 0 ? void 0 : _successResp$delivery8.deliveryTime), DATE_CONSIDERATIONS.DATE_TIME_FORMAT_WITH_SLASH).toDate() : null
          }
        }
      });
    }
  }, {
    key: "loginAndGetUserProfile",
    value: function () {
      var _loginAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(userName, password) {
        var saveCardToProfile,
            jwtToken,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                saveCardToProfile = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
                jwtToken = _args2.length > 3 ? _args2[3] : undefined;
                _context2.next = 4;
                return this.login(userName, password, saveCardToProfile);

              case 4:
                return _context2.abrupt("return", this.getCurrentUserProfile({
                  jwtToken: jwtToken
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loginAndGetUserProfile(_x2, _x3) {
        return _loginAndGetUserProfile.apply(this, arguments);
      }

      return loginAndGetUserProfile;
    }()
  }, {
    key: "socialLoginAndGetUserProfile",
    value: function () {
      var _socialLoginAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(userName, password) {
        var saveCardToProfile,
            jwtToken,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                saveCardToProfile = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;
                jwtToken = _args3.length > 3 ? _args3[3] : undefined;
                _context3.next = 4;
                return this.socialLogin(userName, password, saveCardToProfile);

              case 4:
                return _context3.abrupt("return", this.getCurrentUserProfile({
                  jwtToken: jwtToken
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function socialLoginAndGetUserProfile(_x4, _x5) {
        return _socialLoginAndGetUserProfile.apply(this, arguments);
      }

      return socialLoginAndGetUserProfile;
    }()
  }, {
    key: "getFacebookUserInfo",
    value: function () {
      var _getFacebookUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(accessToken) {
        var _userInfo$picture;

        var response, userInfo, name;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.axios.get(this.config.postfix.FACEBOOK_USER_INFO_API, {
                  params: {
                    access_token: accessToken
                  }
                });

              case 2:
                response = _context4.sent;
                userInfo = response.data;
                name = extractFromFullName(userInfo.name);
                return _context4.abrupt("return", {
                  type: SocialMediaType.GOOGLEPLUS,
                  id: userInfo.id,
                  email: userInfo.email,
                  picture: (_userInfo$picture = userInfo.picture) === null || _userInfo$picture === void 0 ? void 0 : _userInfo$picture.data,
                  firstName: name.first,
                  lastName: name.last
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getFacebookUserInfo(_x6) {
        return _getFacebookUserInfo.apply(this, arguments);
      }

      return getFacebookUserInfo;
    }()
  }, {
    key: "getGoogleUserInfo",
    value: function () {
      var _getGoogleUserInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(accessToken) {
        var response, userInfo;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.axios.get(this.config.postfix.GOOGLE_USER_INFO_API, {
                  params: {
                    access_token: accessToken
                  }
                });

              case 2:
                response = _context5.sent;
                userInfo = response.data;
                return _context5.abrupt("return", {
                  type: SocialMediaType.GOOGLEPLUS,
                  id: userInfo.id,
                  email: userInfo.email,
                  picture: {
                    url: userInfo.picture
                  },
                  firstName: userInfo.given_name,
                  lastName: userInfo.family_name
                });

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getGoogleUserInfo(_x7) {
        return _getGoogleUserInfo.apply(this, arguments);
      }

      return getGoogleUserInfo;
    }()
  }, {
    key: "socialLogin",
    value: function () {
      var _socialLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(socialUID, socialEmail) {
        var _resp$data;

        var saveCardToProfile,
            commonQueryParams,
            conceptCode,
            locale,
            loginEndpointForNewCerts,
            resp,
            _args6 = arguments;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                saveCardToProfile = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : false;
                commonQueryParams = this.config.getCommonQueryParams();
                conceptCode = this.config.getConceptCode();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                /**
                 * To send the new Layer7 certs endpoint through OTA release, we've hardcoded the Login Endpoint for mobile app
                 */

                loginEndpointForNewCerts = this.config.postfix.LOGIN.replace("upgradeCommonCert=true", "upgradeCommonCert=false").replace("commonCert=false", "commonCert=true");
                _context6.next = 7;
                return this.axios.post(loginEndpointForNewCerts, {
                  socialUID: socialUID,
                  socialEmail: socialEmail,
                  saveCardToProfile: saveCardToProfile,
                  locale: locale
                }, {
                  params: {
                    conceptCode: conceptCode
                  },
                  headers: {
                    enc: "true"
                  }
                });

              case 7:
                resp = _context6.sent;
                return _context6.abrupt("return", (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.successResponse);

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function socialLogin(_x8, _x9) {
        return _socialLogin.apply(this, arguments);
      }

      return socialLogin;
    }()
  }, {
    key: "logout",
    value: function () {
      var _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var resp;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.axios.post(this.config.postfix.LOGOUT);

              case 2:
                resp = _context7.sent;
                return _context7.abrupt("return", resp.data);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function logout() {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(userName, password) {
        var _resp$data2;

        var saveCardToProfile,
            commonQueryParams,
            locale,
            loginEndpointForNewCerts,
            resp,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                saveCardToProfile = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : false;
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                /**
                 * To send the new Layer7 certs endpoint through OTA release, we've hardcoded the Login Endpoint for mobile app
                 */

                loginEndpointForNewCerts = this.config.postfix.LOGIN.replace("upgradeCommonCert=false", "upgradeCommonCert=true").replace("commonCert=true", "commonCert=false");
                _context8.next = 6;
                return this.axios.post(loginEndpointForNewCerts, {
                  login: userName,
                  password: password,
                  saveCardToProfile: saveCardToProfile,
                  locale: locale
                }, {
                  headers: {
                    enc: "true"
                  }
                });

              case 6:
                resp = _context8.sent;
                return _context8.abrupt("return", (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.successResponse);

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function login(_x10, _x11) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "signUp",
    value: function () {
      var _signUp = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(createAccountData) {
        var _createAccountData$sa, _createAccountData$mi, _createAccountData$su, _createAccountData$re, _createAccountData$re2, _createAccountData$se, _createAccountData$se2, _createAccountData$so, _createAccountData$so2, _createAccountData$so3, _resp$data3;

        var commonQueryParams, locale, signUpData, resp;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                signUpData = {
                  login: createAccountData.email,
                  confirmLogin: createAccountData.email,
                  salutation: (_createAccountData$sa = createAccountData.salutation) !== null && _createAccountData$sa !== void 0 ? _createAccountData$sa : "",
                  firstName: createAccountData.firstName,
                  lastName: createAccountData.lastName,
                  middleName: (_createAccountData$mi = createAccountData.middleName) !== null && _createAccountData$mi !== void 0 ? _createAccountData$mi : "",
                  suffix: (_createAccountData$su = createAccountData.suffix) !== null && _createAccountData$su !== void 0 ? _createAccountData$su : "",
                  channel: this.config.getDardenChannel().appChannel,
                  signupSource: this.config.getSignUpSource().appSource,
                  Phone: {
                    "atg-rest-class-type": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                    "atg-rest-values": {
                      phone: createAccountData.phone,
                      phoneExt: "",
                      phoneType: "Mobile"
                    }
                  },
                  Address: {
                    "atg-rest-class-type": PAYLOAD_CONSTANTS.JAVA_UTIL_HASHMAP,
                    "atg-rest-values": {
                      addressLine1: (_createAccountData$re = createAccountData.restaurantAddressLine1) !== null && _createAccountData$re !== void 0 ? _createAccountData$re : "",
                      addressLine2: (_createAccountData$re2 = createAccountData.restaurantAddressLine2) !== null && _createAccountData$re2 !== void 0 ? _createAccountData$re2 : "",
                      addressType: createAccountData.restaurantAddressType,
                      city: createAccountData.restaurantCity,
                      state: createAccountData.restaurantState,
                      zip: createAccountData.restaurantZip,
                      country: createAccountData.restaurantCountry
                    }
                  },
                  dobMonth: createAccountData.dobMonth,
                  dobDay: createAccountData.dobDay,
                  dobYear: createAccountData.dobYear,
                  password: createAccountData.password,
                  confirmpassword: createAccountData.password,
                  securityQuestion: (_createAccountData$se = createAccountData.securityQuestion) !== null && _createAccountData$se !== void 0 ? _createAccountData$se : "null",
                  securityAnswer: (_createAccountData$se2 = createAccountData.securityAnswer) !== null && _createAccountData$se2 !== void 0 ? _createAccountData$se2 : "null",
                  registeredConceptID: this.config.getSiteIds().siteId,
                  guestType: createAccountData.guestType,
                  locale: locale,
                  preferredRestaurantId: createAccountData.preferredRestaurantId,
                  conceptCode: "",
                  socialUID: (_createAccountData$so = createAccountData.socialUID) !== null && _createAccountData$so !== void 0 ? _createAccountData$so : "",
                  socialEmail: (_createAccountData$so2 = createAccountData.socialEmail) !== null && _createAccountData$so2 !== void 0 ? _createAccountData$so2 : "",
                  mobilePay: createAccountData.mobilePay ? "true" : "false",
                  retainCard: createAccountData.retainCard ? "true" : "false",
                  primaryEmailOptin: createAccountData.primaryEmailOptin,
                  socialMediaType: (_createAccountData$so3 = createAccountData.socialMediaType) !== null && _createAccountData$so3 !== void 0 ? _createAccountData$so3 : ""
                };
                _context9.next = 5;
                return this.axios.post(this.config.postfix.SIGNUP, signUpData, {
                  params: {
                    locale: locale
                  }
                });

              case 5:
                resp = _context9.sent;
                return _context9.abrupt("return", (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.successResponse);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function signUp(_x12) {
        return _signUp.apply(this, arguments);
      }

      return signUp;
    }()
  }, {
    key: "signUpAndGetUserProfile",
    value: function () {
      var _signUpAndGetUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(createAccountDate, jwtToken) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.signUp(createAccountDate);

              case 2:
                return _context10.abrupt("return", this.getCurrentUserProfile({
                  jwtToken: jwtToken
                }));

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function signUpAndGetUserProfile(_x13, _x14) {
        return _signUpAndGetUserProfile.apply(this, arguments);
      }

      return signUpAndGetUserProfile;
    }()
  }, {
    key: "performSocialLink",
    value: function performSocialLink(email, socialUID, socialMediaType) {
      var commonQueryParams = this.config.getCommonQueryParams();
      var locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
      return this.axios.post(this.config.postfix.SOCIAL_LINK, {
        locale: locale,
        login: email,
        socialUID: socialUID,
        socialEmail: email,
        socialMediaType: socialMediaType
      }).then(function (response) {
        return response.data;
      });
    }
  }, {
    key: "getCurrentUserProfile",
    value: function () {
      var _getCurrentUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(args) {
        var _this2 = this;

        var jwtToken, headers;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                jwtToken = args.jwtToken;
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                return _context11.abrupt("return", this.axios.get(this.config.postfix.PROFILE, {
                  headers: headers
                }).then(function (resp) {
                  return _this2.processProfileResponse(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function getCurrentUserProfile(_x15) {
        return _getCurrentUserProfile.apply(this, arguments);
      }

      return getCurrentUserProfile;
    }()
  }, {
    key: "processProfileResponse",
    value: function processProfileResponse(resp) {
      var _resp$data4, _response$securityQue, _response$dobDay, _response$dobMonth, _response$dobYear, _response$userId;

      var response = resp === null || resp === void 0 ? void 0 : (_resp$data4 = resp.data) === null || _resp$data4 === void 0 ? void 0 : _resp$data4.response;
      return _objectSpread(_objectSpread({}, response), {}, {
        socialLinkInfo: null,
        securityQuestion: response === null || response === void 0 ? void 0 : (_response$securityQue = response.securityQuestion) === null || _response$securityQue === void 0 ? void 0 : _response$securityQue.toString(),
        dobDay: response === null || response === void 0 ? void 0 : (_response$dobDay = response.dobDay) === null || _response$dobDay === void 0 ? void 0 : _response$dobDay.toString(),
        dobMonth: response === null || response === void 0 ? void 0 : (_response$dobMonth = response.dobMonth) === null || _response$dobMonth === void 0 ? void 0 : _response$dobMonth.toString(),
        dobYear: response === null || response === void 0 ? void 0 : (_response$dobYear = response.dobYear) === null || _response$dobYear === void 0 ? void 0 : _response$dobYear.toString(),
        userId: response === null || response === void 0 ? void 0 : (_response$userId = response.userId) === null || _response$userId === void 0 ? void 0 : _response$userId.toString(),
        preferredRestaurantList: response === null || response === void 0 ? void 0 : response.preferredRestaurant
      });
    }
  }, {
    key: "getOrderHistory",
    value: function () {
      var _getOrderHistory = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(jwtToken) {
        var _response$data2, _response$data2$order, _response$data2$order2, headers, response;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                headers = {};

                if (jwtToken) {
                  headers = {
                    Authorization: "Bearer ".concat(jwtToken)
                  };
                }

                _context12.next = 5;
                return this.axios.get(this.config.postfix.ORDER_HISTORY_API, {
                  headers: headers
                });

              case 5:
                response = _context12.sent;
                return _context12.abrupt("return", response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$order = _response$data2.orderHistory) === null || _response$data2$order === void 0 ? void 0 : (_response$data2$order2 = _response$data2$order.orderSummary) === null || _response$data2$order2 === void 0 ? void 0 : _response$data2$order2.map(function (orderItem) {
                  var _orderItem$order, _orderItem$order$rest, _orderItem$order2;

                  var address = orderItem === null || orderItem === void 0 ? void 0 : (_orderItem$order = orderItem.order) === null || _orderItem$order === void 0 ? void 0 : (_orderItem$order$rest = _orderItem$order.restaurantAddres) === null || _orderItem$order$rest === void 0 ? void 0 : _orderItem$order$rest.address;
                  var paymentGroup = orderItem === null || orderItem === void 0 ? void 0 : (_orderItem$order2 = orderItem.order) === null || _orderItem$order2 === void 0 ? void 0 : _orderItem$order2.paymentGroup;
                  return merge(orderItem, {
                    order: {
                      restaurantAddress: {
                        stateCode: address === null || address === void 0 ? void 0 : address.stateCode,
                        city: address === null || address === void 0 ? void 0 : address.city,
                        country: (address === null || address === void 0 ? void 0 : address.country) || null,
                        countyCode: (address === null || address === void 0 ? void 0 : address.countryCode) || null,
                        state: (address === null || address === void 0 ? void 0 : address.stateCode) || null,
                        address1: (address === null || address === void 0 ? void 0 : address.street1) || null,
                        address2: (address === null || address === void 0 ? void 0 : address.street2) || null,
                        countryName: address === null || address === void 0 ? void 0 : address.country,
                        zipCode: address === null || address === void 0 ? void 0 : address.zipCode
                      },
                      paymentDetails: paymentGroup === null || paymentGroup === void 0 ? void 0 : paymentGroup.map(function (paymentOption) {
                        var _ref2;

                        return {
                          creditCardType: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.creditCardType,
                          amount: (_ref2 = (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.amount) + (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.tipAmount) + (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.paygrpTipAmount)) !== null && _ref2 !== void 0 ? _ref2 : 0,
                          paygrpTipAmount: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.paygrpTipAmount,
                          tipAmount: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.tipAmount,
                          paymentMethod: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.paymentMethod,
                          paymentCardToken: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.paymentCardToken,
                          giftCardNumber: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.giftCardNumber,
                          giftCardType: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.giftCardType,
                          walletType: paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.walletType
                        };
                      })
                    }
                  });
                }));

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", []);

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 9]]);
      }));

      function getOrderHistory(_x16) {
        return _getOrderHistory.apply(this, arguments);
      }

      return getOrderHistory;
    }()
  }, {
    key: "getProfileOrders",
    value: function () {
      var _getProfileOrders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(jwtToken) {
        var _this3 = this;

        var headers;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                headers = {};

                if (jwtToken) {
                  headers = {
                    Authorization: "Bearer ".concat(jwtToken)
                  };
                }

                _context13.next = 4;
                return this.axios.get(this.config.postfix.USER_PROFILE_ORDERS, {
                  headers: headers
                }).then(function (resp) {
                  return _this3._processProfileOrders(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 4:
                return _context13.abrupt("return", _context13.sent);

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function getProfileOrders(_x17) {
        return _getProfileOrders.apply(this, arguments);
      }

      return getProfileOrders;
    }()
  }, {
    key: "_processProfileOrders",
    value: function _processProfileOrders(resp) {
      var _resp$data5, _resp$data6;

      if ((resp === null || resp === void 0 ? void 0 : (_resp$data5 = resp.data) === null || _resp$data5 === void 0 ? void 0 : _resp$data5.statusCode) === 500) {
        throw new Error("Unable to load order history");
      }

      return (resp === null || resp === void 0 ? void 0 : (_resp$data6 = resp.data) === null || _resp$data6 === void 0 ? void 0 : _resp$data6.response) || {
        totalordercount: 0,
        orderSummary: []
      };
    }
  }, {
    key: "rateVisit",
    value: function () {
      var _rateVisit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(params) {
        var _resp$data7;

        var resp;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.axios.post(this.config.postfix.RATE_YOUR_VISIT, _objectSpread({}, params));

              case 2:
                resp = _context14.sent;
                return _context14.abrupt("return", resp === null || resp === void 0 ? void 0 : (_resp$data7 = resp.data) === null || _resp$data7 === void 0 ? void 0 : _resp$data7.successResponse);

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function rateVisit(_x18) {
        return _rateVisit.apply(this, arguments);
      }

      return rateVisit;
    }()
  }, {
    key: "updateProfile",
    value: function () {
      var _updateProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(payload, userId) {
        var _resp$data8;

        var commonQueryParams, locale, reqBody, resp;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = _objectSpread(_objectSpread({}, payload), {}, {
                  locale: locale,
                  conceptCode: this.config.getConceptCode()
                });
                _context15.next = 5;
                return this.axios.post(this.config.postfix.UPDATE_PROFILE, reqBody, {
                  params: {
                    userId: userId
                  }
                });

              case 5:
                resp = _context15.sent;
                return _context15.abrupt("return", (_resp$data8 = resp.data) === null || _resp$data8 === void 0 ? void 0 : _resp$data8.successResponse);

              case 7:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function updateProfile(_x19, _x20) {
        return _updateProfile.apply(this, arguments);
      }

      return updateProfile;
    }()
  }, {
    key: "updateUserPassword",
    value: function () {
      var _updateUserPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(payload) {
        var _resp$data9;

        var commonQueryParams, locale, reqBody, resp;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = _objectSpread(_objectSpread({}, payload), {}, {
                  locale: locale,
                  conceptCode: this.config.getConceptCode()
                });
                _context16.next = 5;
                return this.axios.post(this.config.postfix.CHANGE_PASSWORD, reqBody);

              case 5:
                resp = _context16.sent;
                return _context16.abrupt("return", (_resp$data9 = resp.data) === null || _resp$data9 === void 0 ? void 0 : _resp$data9.successResponse);

              case 7:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function updateUserPassword(_x21) {
        return _updateUserPassword.apply(this, arguments);
      }

      return updateUserPassword;
    }()
  }, {
    key: "getSettingsList",
    value: function () {
      var _getSettingsList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(settingType) {
        var commonQueryParams, locale, conceptCode, resp;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                conceptCode = this.config.getConceptCode();
                _context17.prev = 3;
                _context17.next = 6;
                return this.axios.get("".concat(this.config.postfix.GET_SETTING_DATA_API, "/").concat(settingType, "?conceptCode=").concat(conceptCode, "&locale=").concat(locale, "&channel=mobileapp"));

              case 6:
                resp = _context17.sent;
                return _context17.abrupt("return", resp.data);

              case 10:
                _context17.prev = 10;
                _context17.t0 = _context17["catch"](3);
                console.log(_context17.t0);

              case 13:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[3, 10]]);
      }));

      function getSettingsList(_x22) {
        return _getSettingsList.apply(this, arguments);
      }

      return getSettingsList;
    }()
  }, {
    key: "addPhoneNumber",
    value: function () {
      var _addPhoneNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(args) {
        var _this4 = this;

        var jwtToken, payload, headers;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                jwtToken = args.jwtToken, payload = args.payload;
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                return _context18.abrupt("return", this.axios.post(this.config.postfix.EDIT_PROFILE_PHONE.replace("/{phoneId}", ""), payload, {
                  headers: headers
                }).then(function (resp) {
                  return _this4.processProfileResponse(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function addPhoneNumber(_x23) {
        return _addPhoneNumber.apply(this, arguments);
      }

      return addPhoneNumber;
    }()
  }, {
    key: "updatePhoneNumber",
    value: function () {
      var _updatePhoneNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(args) {
        var _this5 = this;

        var jwtToken, payload, headers;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                jwtToken = args.jwtToken, payload = args.payload;
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                return _context19.abrupt("return", this.axios.put(this.config.postfix.EDIT_PROFILE_PHONE.replace("/{phoneId}", ""), payload, {
                  headers: headers
                }).then(function (resp) {
                  return _this5.processProfileResponse(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function updatePhoneNumber(_x24) {
        return _updatePhoneNumber.apply(this, arguments);
      }

      return updatePhoneNumber;
    }()
  }, {
    key: "updateEmailAddress",
    value: function () {
      var _updateEmailAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(args) {
        var _this6 = this;

        var jwtToken, payload, headers;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                jwtToken = args.jwtToken, payload = args.payload;
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                return _context20.abrupt("return", this.axios.put(this.config.postfix.EDIT_PROFILE_EMAIL, payload, {
                  headers: headers
                }).then(function (resp) {
                  return _this6.processProfileResponse(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function updateEmailAddress(_x25) {
        return _updateEmailAddress.apply(this, arguments);
      }

      return updateEmailAddress;
    }()
  }, {
    key: "updateProfileName",
    value: function () {
      var _updateProfileName = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(args) {
        var _this7 = this;

        var jwtToken, payload, headers;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                jwtToken = args.jwtToken, payload = args.payload;
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                return _context21.abrupt("return", this.axios.put(this.config.postfix.EDIT_PROFILE_NAME, payload, {
                  headers: headers
                }).then(function (resp) {
                  return _this7.processProfileResponse(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function updateProfileName(_x26) {
        return _updateProfileName.apply(this, arguments);
      }

      return updateProfileName;
    }()
  }, {
    key: "updatePassword",
    value: function () {
      var _updatePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(args) {
        var _this8 = this;

        var jwtToken, payload, headers;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                jwtToken = args.jwtToken, payload = args.payload;
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                return _context22.abrupt("return", this.axios.put(this.config.postfix.EDIT_PROFILE_PASSWORD, payload, {
                  headers: headers
                }).then(function (resp) {
                  return _this8.processProfileResponse(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this);
      }));

      function updatePassword(_x27) {
        return _updatePassword.apply(this, arguments);
      }

      return updatePassword;
    }()
  }, {
    key: "updatePreferredLocation",
    value: function () {
      var _updatePreferredLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(args) {
        var _this9 = this;

        var jwtToken, payload, headers;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                jwtToken = args.jwtToken, payload = args.payload;
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                return _context23.abrupt("return", this.axios.post(this.config.postfix.EDIT_PROFILE_FAV_LOCATION, payload, {
                  headers: headers
                }).then(function (resp) {
                  return _this9.processProfileResponse(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function updatePreferredLocation(_x28) {
        return _updatePreferredLocation.apply(this, arguments);
      }

      return updatePreferredLocation;
    }()
  }, {
    key: "updateDob",
    value: function () {
      var _updateDob = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(args) {
        var _this10 = this;

        var jwtToken, payload, headers;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                jwtToken = args.jwtToken, payload = args.payload;
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                return _context24.abrupt("return", this.axios.put(this.config.postfix.EDIT_PROFILE_DOB, payload, {
                  headers: headers
                }).then(function (resp) {
                  return _this10.processProfileResponse(resp);
                })["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function updateDob(_x29) {
        return _updateDob.apply(this, arguments);
      }

      return updateDob;
    }()
  }, {
    key: "resetPasswordRequest",
    value: function () {
      var _resetPasswordRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(payload) {
        var _resp$data10;

        var commonQueryParams, locale, reqBody, resp;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = _objectSpread(_objectSpread({}, payload), {}, {
                  locale: locale,
                  conceptCode: this.config.getConceptCode()
                });
                _context25.next = 5;
                return this.axios.post(this.config.postfix.RESET_PASSWORD_REQUEST, reqBody);

              case 5:
                resp = _context25.sent;
                return _context25.abrupt("return", (_resp$data10 = resp.data) === null || _resp$data10 === void 0 ? void 0 : _resp$data10.successResponse);

              case 7:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this);
      }));

      function resetPasswordRequest(_x30) {
        return _resetPasswordRequest.apply(this, arguments);
      }

      return resetPasswordRequest;
    }()
  }, {
    key: "resetPassword",
    value: function () {
      var _resetPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(payload) {
        var _resp$data11;

        var commonQueryParams, locale, reqBody, resp;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                reqBody = _objectSpread(_objectSpread({}, payload), {}, {
                  locale: locale,
                  conceptCode: this.config.getConceptCode()
                });
                _context26.next = 5;
                return this.axios.post(this.config.postfix.RESET_PASSWORD, reqBody);

              case 5:
                resp = _context26.sent;
                return _context26.abrupt("return", (_resp$data11 = resp.data) === null || _resp$data11 === void 0 ? void 0 : _resp$data11.successResponse);

              case 7:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this);
      }));

      function resetPassword(_x31) {
        return _resetPassword.apply(this, arguments);
      }

      return resetPassword;
    }()
  }, {
    key: "updateFavoriteLocation",
    value: function () {
      var _updateFavoriteLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(args) {
        var jwtToken, restaurantNum, favouriteLocationAction, headers;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                jwtToken = args.jwtToken, restaurantNum = args.restaurantNum, favouriteLocationAction = args.favouriteLocationAction;
                headers = {
                  "X-Concept-Code": this.config.getConceptCode(),
                  Authorization: "Bearer ".concat(jwtToken)
                };
                _context27.prev = 2;
                _context27.t0 = favouriteLocationAction;
                _context27.next = _context27.t0 === "add" ? 6 : _context27.t0 === "remove" ? 9 : 12;
                break;

              case 6:
                _context27.next = 8;
                return this.addToFavorites(headers, restaurantNum);

              case 8:
                return _context27.abrupt("break", 12);

              case 9:
                _context27.next = 11;
                return this.removeFromFavorites(headers, restaurantNum);

              case 11:
                return _context27.abrupt("break", 12);

              case 12:
                _context27.next = 17;
                break;

              case 14:
                _context27.prev = 14;
                _context27.t1 = _context27["catch"](2);
                throw new UIError(_context27.t1);

              case 17:
                _context27.next = 19;
                return this.getFavoriteLocations(jwtToken);

              case 19:
                return _context27.abrupt("return", _context27.sent);

              case 20:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this, [[2, 14]]);
      }));

      function updateFavoriteLocation(_x32) {
        return _updateFavoriteLocation.apply(this, arguments);
      }

      return updateFavoriteLocation;
    }()
  }, {
    key: "addToFavorites",
    value: function () {
      var _addToFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(headers, restaurantNumber) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                payload = {
                  restaurantNum: restaurantNumber
                };
                _context28.next = 3;
                return this.axios.post(this.config.postfix.ADD_RESTAURANT_TO_FAVORITES, payload, {
                  headers: headers
                }).then(function (response) {
                  var _response$data3;

                  if (response !== null && response !== void 0 && (_response$data3 = response.data) !== null && _response$data3 !== void 0 && _response$data3.errors) {
                    var _response$data4;

                    throw {
                      errors: response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.errors
                    };
                  }
                })["catch"](function (err) {
                  throw err;
                });

              case 3:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, this);
      }));

      function addToFavorites(_x33, _x34) {
        return _addToFavorites.apply(this, arguments);
      }

      return addToFavorites;
    }()
  }, {
    key: "removeFromFavorites",
    value: function () {
      var _removeFromFavorites = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(headers, restaurantNumber) {
        var commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                _context29.next = 4;
                return this.axios["delete"](this.config.postfix.REMOVE_RESTAURANT_FROM_FAVORITES.replace("{restaurantNumber}", restaurantNumber), {
                  headers: headers,
                  params: {
                    locale: locale
                  }
                }).then(function (response) {
                  var _response$data5;

                  if (response !== null && response !== void 0 && (_response$data5 = response.data) !== null && _response$data5 !== void 0 && _response$data5.errors) {
                    var _response$data6;

                    throw {
                      errors: response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.errors
                    };
                  }
                })["catch"](function (err) {
                  throw err;
                });

              case 4:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, this);
      }));

      function removeFromFavorites(_x35, _x36) {
        return _removeFromFavorites.apply(this, arguments);
      }

      return removeFromFavorites;
    }()
  }, {
    key: "getFavoriteLocations",
    value: function () {
      var _getFavoriteLocations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(jwtToken) {
        var headers, favLocations;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                headers = {
                  Authorization: "Bearer ".concat(jwtToken)
                };
                favLocations = [];
                _context30.next = 4;
                return this.axios.get(this.config.postfix.PROFILE_FAVORITE_LOCATIONS, {
                  headers: headers
                }).then(function (resp) {
                  var _resp$data12;

                  return resp === null || resp === void 0 ? void 0 : (_resp$data12 = resp.data) === null || _resp$data12 === void 0 ? void 0 : _resp$data12.favoriteRestaurants;
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 4:
                favLocations = _context30.sent;
                return _context30.abrupt("return", favLocations);

              case 6:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function getFavoriteLocations(_x37) {
        return _getFavoriteLocations.apply(this, arguments);
      }

      return getFavoriteLocations;
    }()
  }, {
    key: "getSettings",
    value: function () {
      var _getSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(type) {
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                return _context31.abrupt("return", this.getSettingsList(type));

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function getSettings(_x38) {
        return _getSettings.apply(this, arguments);
      }

      return getSettings;
    }()
  }, {
    key: "getRecentOrderDetailsForNonLoggedinUser",
    value: function () {
      var _getRecentOrderDetailsForNonLoggedinUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(data) {
        var conceptCode, commonQueryParams, locale, payload, response;
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                conceptCode = this.config.getConceptCode();
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                payload = {
                  ordersInfo: {
                    "atg-rest-class-type": "java.util.ArrayList",
                    "atg-rest-class-descriptor": {
                      "atg-rest-values": {
                        "container-class": "java.util.ArrayList",
                        "element-class": "com.darden.commerce.order.OrdersInfo"
                      }
                    },
                    "atg-rest-values": data
                  }
                };
                _context32.prev = 4;
                _context32.next = 7;
                return this.axios.post(this.config.postfix.ORDER_DETAILS, payload, {
                  params: {
                    conceptCode: conceptCode,
                    locale: locale
                  },
                  headers: {
                    "x-retry-on-timeout": true
                  }
                });

              case 7:
                response = _context32.sent;
                return _context32.abrupt("return", response.data.successResponse);

              case 11:
                _context32.prev = 11;
                _context32.t0 = _context32["catch"](4);
                return _context32.abrupt("return", null);

              case 14:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this, [[4, 11]]);
      }));

      function getRecentOrderDetailsForNonLoggedinUser(_x39) {
        return _getRecentOrderDetailsForNonLoggedinUser.apply(this, arguments);
      }

      return getRecentOrderDetailsForNonLoggedinUser;
    }()
  }, {
    key: "decryptLegacyEncryptedData",
    value: function () {
      var _decryptLegacyEncryptedData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(data) {
        var xmlenc, xmlencOpts;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                // XML Response
                xmlenc = this.config.getMessageEncryptionUtil();
                xmlencOpts = this.config.getMessageEncryptionOpts();

                if (!(xmlenc && xmlencOpts && typeof xmlenc.decryptPayload === "function")) {
                  _context34.next = 6;
                  break;
                }

                return _context34.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(resolve, reject) {
                    var _yield$handle, _yield$handle2, error, decryptedResponse;

                    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
                      while (1) {
                        switch (_context33.prev = _context33.next) {
                          case 0:
                            _context33.next = 2;
                            return handle(xmlenc.decryptPayload(data, xmlencOpts.privateKey));

                          case 2:
                            _yield$handle = _context33.sent;
                            _yield$handle2 = _slicedToArray(_yield$handle, 2);
                            error = _yield$handle2[0];
                            decryptedResponse = _yield$handle2[1];

                            if (error) {
                              reject("unable to decrypt" + error);
                            } else {
                              resolve(decryptedResponse);
                            }

                          case 7:
                          case "end":
                            return _context33.stop();
                        }
                      }
                    }, _callee33);
                  }));

                  return function (_x41, _x42) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 6:
                return _context34.abrupt("return", null);

              case 7:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this);
      }));

      function decryptLegacyEncryptedData(_x40) {
        return _decryptLegacyEncryptedData.apply(this, arguments);
      }

      return decryptLegacyEncryptedData;
    }()
  }, {
    key: "lastSessionDetailTimeStamp",
    get: function get() {
      return this._lastSessionDetailTimeStamp;
    }
  }]);

  return User;
}();

export { User as default };